import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <TopicsSection />
        <RankingSection />
        <MediaSection />
        <FAQSection />
        <FeaturesSection />
        <CommentsSection />
        <IndexSection />
        <UpdatesSection />
        <CarouselSection />
        <ContactSection />
        <CardsSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}